import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Image, Mask } from "antd-mobile";
import styles from "./index.module.less";
import { game_result_bg, game_result_fail, game_result_fail_icon, game_result_info, game_result_success, game_result_success_icon, game_result_week_icon, game_share_logo, game_share_qr} from "~src/assets/images/answerGame";
import classNames from "classnames";
import html2canvas from "html2canvas";
import { getScore } from "~src/service/answer";
import { StatusType } from "~src/service/answer/answer";
import { useNavigate } from "react-router-dom";
import MaskShare from "~src/components/DialogContent";
import useSendCurrentPagePath from "~src/hooks/useSendCurrentPagePath";

const RankingList: FC = () => {
  const shareRef = useRef<any>()
  const navigate = useNavigate()
  const [visibleShre, setVisibleShre] = useState<boolean>(false)
  const [scoreData, setScoreData] = useState<StatusType>({} as StatusType)
  const [militaryUrl, setMilitaryUrl] = useState<string>("")
  const [visible, setVisible] = useState<boolean>(false)
  const { sendMessage } = useSendCurrentPagePath()
  sendMessage({
    title: "和绿喵一起涨知识，答对4题赢低碳惊喜好礼",
    type: "share",
    path: "",
    basePath: "/pages/answer_game/index",
    shareQuery: "?share=true&type=all",
    selfQuery: "&share=true&type=all"
  })
  const avatar = useMemo(() => {
    return localStorage.getItem("mio-avatarUrl") || ""
  }, [])
  const nickname = useMemo(() => {
    return localStorage.getItem("mio-nickname") || ""
  }, [])

  const initHtml2Canvas = () => {
    html2canvas(shareRef.current,
      {
        allowTaint: true,
        useCORS: true,
        logging: true,
        backgroundColor: null,
      }
    ).then(function (canvas) {
      let img = canvas.toDataURL("image/png");
      setMilitaryUrl(img)
    });
  }
  const onMilitaryExploits = () => {
    setVisible(true)
  }
  const getScoreData = useCallback(async () => {
    const data = await getScore()
    setScoreData(data)
    setTimeout(() => {
      initHtml2Canvas()
    }, 1000)
  }, [])
  useEffect(() => {
    getScoreData()
  }, [getScoreData])
  return <div className={styles.result}>
    <Image className={styles.game_result_bg} src={game_result_bg} />
    <div className={styles["result-content"]}>
      <div className={styles["result-content-icon"]}>
        <Image className={styles.game_result_success} src={!!scoreData.status ? game_result_success : game_result_fail} />
        <Image className={styles.game_result_success_icon} src={!!scoreData.status ? game_result_success_icon : game_result_fail_icon} />
      </div>
      <div className={styles["result-content-info"]} ref={shareRef}>
        <div className={styles["result-content-info-per"]}>
          <Image className={styles.game_result_info} src={game_result_info}></Image>
          <div className={styles["result-content-info-per-title"]}>
            <Image className={styles["result-content-info-per-title-ava"]} crossOrigin="anonymous" src={avatar}></Image>
            <div className={styles["result-content-info-per-title-name"]}>{nickname}</div>
          </div>
        </div>
        <div className={styles["result-content-info-data"]}>
          <div className={styles["result-content-info-data-detil"]}>
            <div className={styles["result-content-info-data-items"]}>
              <div className={styles["result-content-info-data-items-label"]}>答对题数</div>
              <div className={styles["result-content-info-data-items-value"]}>
                <span className={styles["result-content-info-data-items-value-num"]}>{scoreData.coreect}</span>
                道题
              </div>
            </div>
            <div className={styles["result-content-info-data-items"]}>
              <div className={styles["result-content-info-data-items-label"]}>排名</div>
              <div className={styles["result-content-info-data-items-value"]}>
                第
                <span className={styles["result-content-info-data-items-value-num"]}>{!!scoreData.ranking ? scoreData.ranking : <span style={{ fontSize: "16px" }}>/</span>}</span>
                名
              </div>
            </div>
            <div className={styles["result-content-info-data-items"]}>
              <div className={styles["result-content-info-data-items-label"]}>获得积分</div>
              <div className={styles["result-content-info-data-items-value"]}>
                <span className={styles["result-content-info-data-items-value-num"]}>{scoreData.point}</span>
                积分
              </div>
            </div>
          </div>
          <div className={styles["result-content-slogan"]}>
            每天1分钟，和绿喵一起涨知识
            {/* <Image className={styles["result-content-slogan-name"]} src={game_slogan_success}></Image> */}
          </div>
          <div className={styles.share}>
            <div>
              <Image className={styles.game_share_logo} src={game_share_logo}></Image>
            </div>
            <div className={styles["share-qr"]}>
              <Image className={styles.game_share_qr} src={game_share_qr}></Image>
              <div>长按识别小程序码</div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={styles.btns}>
        <div className={styles.invite} onClick={() => { setVisibleShre(true) }}>邀请好友一起涨知识</div>
        <div className={styles.ther}>
          <div className={classNames(styles["share-btn"], styles["ther-result"])}
            onClick={onMilitaryExploits}>晒战绩</div>
          <div className={classNames(styles["share-btn"], styles["ther-ranking"])} onClick={
            () => {
              navigate("/answer/rankingList")
            }
          }>
            排行榜
            <Image className={styles.game_result_week_icon} src={game_result_week_icon}></Image>
          </div>
        </div>
      </div> */}
    </div>
    <Mask visible={visible} onMaskClick={() => setVisible(false)}>
      <div className={styles.military}>
        <Image className={styles["military-url"]} src={militaryUrl}></Image>
        <div className={styles.tips}>长按保存图片分享</div>
      </div>
    </Mask>
    <MaskShare tips={
      <>
        <div>点击分享</div>
        <div>邀请好友助力</div>
      </>
    } visible={visibleShre} onMaskClick={() => { setVisibleShre(false) }} />
  </div>
}
export default RankingList